import { FaAngleLeft, FaAngleRight } from "react-icons/fa";

const Pagination = (props) => {
    const limit = [10,20,50,100,200,500]
    const handleLimit = (event) => {
        if (props.onLimitChange && !props.disabled) {
            props.onLimitChange(event);
        }
    }
    const handlePrev = (event) => {
        if (props.onPrevChange && !props.disabled) {
            props.onPrevChange(event);
        }
    }
    const handleNext = (event) => {
        if (props.onNextChange && !props.disabled) {
            props.onNextChange(event);
        }
    }
    const handleChangePage = (event) => {
        if (props.onNextChange && !props.disabled) {
            props.onChangePage(event);
        }
    }
    const handleSearchPage = (event) => {
        if (props.onNextChange && !props.disabled) {
            props.onSearchPage(event);
        }
    }

    return (
        <div className=' flex items-center justify-between pb-4 mt-2'>
            <div className=' flex items-center gap-2'>
                <div className='grayBlurShadow px-3 py-1 rounded-lg'>
                    <select value={props?.limit} disabled={props.disabled} onChange={handleLimit} >
                        {limit?.map((val) => {
                            return <option key={val} value={val}>{val}</option>
                        })}
                    </select>
                </div>
                <div className='grayBlurShadow px-3 py-1.5 text-sm font-semibold rounded-lg'>
                    <h1>Total Records: {props?.totalRecords}</h1>
                </div>
                <div className='grayBlurShadow px-3 py-1.5  text-sm font-semibold rounded-lg'>
                    <h1>Total Pages: {props?.allPages}</h1>
                </div>
            </div>
            {props.onChangePage && props.onSearchPage && (
                <div className='px-3 flex gap-1 items-center'>
                    <h1>Search Page: </h1>
                    <input value={props.page} disabled={props.disabled} type="number" placeholder='' className='border-2 px-3 w-20' 
                    onChange={handleChangePage} />
                    <button className={`${props.disabled ? " cursor-not-allowed" : ""} darkPurple text-white font-semibold rounded-lg px-4 text-sm py-1 mx-2 hoverGreen`} 
                    onClick={(e) => {
                        handleSearchPage(e)
                    }}>Search</button>
                </div>
            )}
            <div className='flex items-center grayBlurShadow px-3 py-1 rounded-lg'>
                <button onClick={handlePrev}>
                    <FaAngleLeft className={` text-xl ${props?.disabledPrev || props.disabled ? " text-gray-200 cursor-not-allowed" : " text-gray-500"}`} />
                </button>
                <div className=' px-3'>
                    {props.page}
                </div>
                <button onClick={handleNext}>
                    <FaAngleRight className={` text-xl ${props?.disabledNext || props.disabled ? " text-gray-200 cursor-not-allowed" : " text-gray-500"}`} />
                </button>
            </div>
        </div>
    );
}

export default Pagination;
